import React from 'react';
import { DocumentChartBarIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

/**
 * Compact card shown inline when a message has an HTML chart artifact.
 * Clicking "View" opens the artifact in the sliding right panel.
 */
const ArtifactViewCard = ({ onView, darkMode }) => (
  <button
    type="button"
    onClick={onView}
    className={`mt-3 w-full flex items-center justify-between gap-3 p-4 rounded-2xl border transition-all text-left hover:shadow-md ${
      darkMode
        ? 'border-[#333] bg-[#1a1a1a] hover:bg-[#222] hover:border-[#444]'
        : 'border-gray-200 bg-gray-50 hover:bg-gray-100 hover:border-gray-300'
    }`}
  >
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center flex-shrink-0">
        <DocumentChartBarIcon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
      </div>
      <div className="min-w-0">
        <div className="font-medium text-gray-900 dark:text-white">
          View in side panel
        </div>
      </div>
    </div>
    <ChevronRightIcon className="w-5 h-5 text-gray-400 dark:text-gray-500 flex-shrink-0" />
  </button>
);

export default ArtifactViewCard;
